// System roles are fixed by the backend contract and safe to hardcode.
// Values MUST match `userInfo.role.systemRole` as emitted by the backend
// (role object shape: { id, name, systemRole, isDefault, ... }).
//
// Only ADMIN is active in the current product. MERCHANT/PSP/AGENT are
// placeholder names inherited from an earlier product — their branches
// remain in the codebase so future roles can be enabled with a small
// edit here plus a change to the admin-facing roles dropdown. When real
// role names become known, rename the keys and values in this object
// and run a find-replace; downstream references update automatically.
//
// Historical note: the legacy value `appz` in earlier code was an alias
// for admin — collapsed into ADMIN here.
export const SYSTEM_ROLES = Object.freeze({
    ADMIN: 'admin',
    MERCHANT: 'merchant',
    PSP: 'psp',
    AGENT: 'agent'
});
